import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetBanners(payload) {
    return Api().get("/api/cinema/banners");
  },
  updateSeatStatus(payload) {
    return Api().put("/update-seat-status", payload);
  },
  getOrgDetails() {
    return Api().get("/api/pos/getOrgDetails");
  },
  GetTodaysScreening(payload) {
    const cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    const query = createQueryString(payload);
    return Api().get(`/api/cinema/admin/now-showing-confirmed-list${query}`);
  },
  GetCreateOwnShow(payload) {
    const cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    const query = createQueryString(payload);
    return Api().get(`/api/cinema/admin/now-showing-list${query}&onDemand=true`);
  },
  GetComingSoon(payload) {
    const cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    const query = createQueryString(payload);
    return Api().get(`/api/cinema/admin/upcoming-show-list${query}`);
  },
  SearchMovie(payload) {
    payload.limit = 5;
    payload.currentPage = 1;
    const query = createQueryString(payload);
    return Api().get(`/api/cinema/admin/search-movie${query}`);
  },
  GetMovieDetails(payload) {
    const {
      movie_id,
      content_lang_id,
      cinema_id,
      md_for_ondemand,
      guest_user_id,
      cust_id
    } = payload;
    const query = createQueryString({
      cinema_id,
      md_for_ondemand,
      guest_user_id,
      cust_id
    });
    return Api().get(
      `/api/cinema/movie-detail/${movie_id}/${content_lang_id}/${query}`
    );
  },
  getMovieConfirmedList(payload) {
    const { movie_id, cinema_id } = payload;
    const query = createQueryString(payload);
    return Api().get(
      `/api/cinema/admin/movie-confirmed-list/${movie_id}${query}`
    );
  },

  getScheduleDetails(payload) {
    const { ss_id } = payload;
    return Api().get(`/api/cinema/schedule-details/${ss_id}`);
  },
  getSeatLayout(payload) {
    return Api().post(`/api/external/seat-layout/`, payload);
  },

  getSeatLayoutCreateScreen(payload) {
    return Api().post(`/api/cinema/admin/seat-layout-list/`, payload);
  },
  ReserveSeats(payload) {
    return Api().post(`/api/cinema/reserve-seat/`, payload);
  },
  ReserveSeatsCreateShow(payload) {
    return Api().post(`/api/cinema/admin/reserve-seats`, payload);
  },
  GetCountries() {
    return Api().get("/api/external/countries");
  },
  GetReservationDetails(payload) {
    const { reservation_id } = payload;
    return Api().get(`/api/external/reservation-detail/${reservation_id}`);
  },
  GetCreateShowReservationDetails(payload) {
    const { reservation_id } = payload;
    return Api().get(`/api/cinema/admin/reservation-detail/${reservation_id}`);
  },

  GetCreateShowDetails(payload) {
    let { movie_id, cinema_id, guest_user_id, fromDate } = payload;

    const query = createQueryString({
      cinema_id,
      guest_user_id,
      fromDate
    });

    return Api().get(
      `/api/cinema/admin/v2/movie-schedule-list/${movie_id}${query}`
    );
  },
  ReserveShowsMyCinema(payload) {
    return Api().post(`/api/cinema/admin/create-schedule/`, payload);
    // https://cinematic-server-imaculix-1.brij.tech/api/cinema/admin/screening-type-list?mycinema_ss_d_id=901
  },
  GetScreeningType(payload) {
    let { mycinema_ss_d_id } = payload;

    const query = createQueryString({
      mycinema_ss_d_id
    });
    return Api().get(`/api/cinema/admin/screening-type-list/${query}`);
  },
  BookSeats(payload) {
    return Api().post(`/api/cinema/book-seat`, payload);
  },
  VistaBookSeats(payload) {
    return Api().post(`/api/external/vista/book-seats-vista`, payload);
  },
  GetBookingDetails(payload) {
    const { sb_id } = payload;
    return Api().get(`/api/cinema/booking-details/${sb_id}`, payload);
  },
  GetBookingDetailsVista(payload) {
    const { sb_id } = payload;
    return Api().get(`/api/external/vista/getBookingDetails/${sb_id}`, payload);
  },
  GetCinemaList(payload) {
    const query = createQueryString(payload);
    return Api().post(`/api/external/cinemas${query}`, payload);
  },
  GetActivePaymentModes(payload) {
    return Api().get(`/api/external/payment-modes/${payload}`);
  },
  createBrainTreeClientToken(payload) {
    return Api().get(
      `/api/cinema/braintree/generate-client-token/${payload.cust_id}`
    );
  },


  MakePayment(payload) {
    return Api().post(`/api/cinema/braintree/pay`, payload);
  },

  
  MakePaymentWithPaypal(payload) {
    return Api().post(`/api/cinema/paypal/pay`, payload);
  },
  ExecutePaymentWithPaypal(payload) {
    return Api().post(`/api/cinema/paypal/execute`, payload);
  },

  

  MakeVistaPayment(payload) {
    return Api().post(`/api/cinema/braintree/pay-vista`, payload);
  },
  // MakePaymentWithPaypal(payload) {
  //   return Api().post(`/api/cinema/braintree/pay-paypal`, payload);
  // },
  // MakeVistaPaymentWithPaypal(payload) {
  //   return Api().post(`/api/cinema/braintree/pay-vista-paypal`, payload);
  // },
  GetFestivalList(payload) {
    return Api().get(`api/cinema/festival-list`);
  },
  GetMiniFestivals(payload) {
    const cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    const query = createQueryString(payload);
    console.log("query :>> ", query);
    return Api().get(`api/cinema/get-minifestival-list${query}`);
  },
  GetAllRegions() {
    return Api().get(`api/external/getRegions`);
  },
  GetFilterList() {
    return Api().get(`api/cinema/admin/filter-list`);
  },
  GetVistaReservationDetails(payload){
    return Api().get(`api/external/vista/reservation/${payload.orderId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/mainService.js